import axios from "axios";
import { API_ENDPOINT } from "../../common/constants/apiConstants";

export const getActiveInterview = async (email) => {
  const url = `${API_ENDPOINT.GET_STUDENT_DASHBOARD.GET_ACTIVE_INTERVIEWS}`;
  try {
    const response = await axios.post(url,  { email  });
    return response.data;
  } catch (error) {
    console.error("active interviews API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getAllActiveInterviews = async (email, page = 1, limit = 6) => {
  const url = `${API_ENDPOINT.GET_STUDENT_DASHBOARD.GET_ALL_ACTIVE_INTERVIEWS}`;
  try {
    const response = await axios.post(url, { 
      email,
      page,
      limit 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Network error" };
  }
};

export const getCompletedInterviews = async (email, page = 1, limit = 5) => {
  const url = `${API_ENDPOINT.GET_STUDENT_DASHBOARD.GET_COMPLETED_INTERVIEWS}`;
  try {
    const response = await axios.post(url, { 
      email,
      page,
      limit 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Network error" };
  }
};

export const submitStudentSurvey = async (payload) => {
  const url = `${API_ENDPOINT.STUDENT_SURVEY.CREATE}/`;
  try {
    const response = await axios.post(url, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Submit Student Survey API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getStudentInterviewMetrics = async (email) => {
  const url = `${API_ENDPOINT.GET_STUDENT_DASHBOARD.GET_STUDENT_METRICS}`;
  try {
    const response = await axios.post(url, { email });
    return response.data;
  } catch (error) {
    console.error("student interview metrics API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getStudentMarks = async (email, page = 1, limit = 50) => {
  const url = `${API_ENDPOINT.GET_STUDENT_DASHBOARD.STUDENT_MARKS}`;
  try {
    const response = await axios.post(url, { email, page, limit });
    return response.data;
  } catch (error) {
    console.error("Student marks API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getCategoryPerformance = async (email, page = 1, limit = 50) => {
  const url = `${API_ENDPOINT.GET_STUDENT_DASHBOARD.CATEGORY_PERFORMANCE}`;
  try {
    const response = await axios.post(url, { email, page, limit });
    return response.data;
  } catch (error) {
    console.error("Category performance API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};